<template>
    <div>

        <div class="inner-block power-switch hide-lg">
            <div class="label-block">
                <div class="title">Кондиционер</div>
            </div>
            <div class="content-block">
                <material-switch v-model="condey.power" @change="setPower()"
                                 true-value="on" false-value="off"></material-switch>
            </div>
        </div>

        <div class="inner-block" style="border: none; height: 100px">
            <div class="label-block">
                <div class="title">Режим</div>
                <div class="help-info open-help-tooltip" @click="popups.mode=true"></div>
                <div class="hide-md text-main" style="text-align: right; line-height: 19px; flex-grow: 1; font-weight: 500;">
                    {{condeyModesLang[condey.mode]}}
                </div>
            </div>
            <div class="content-block">
                <div class="mode-btn" v-for="(label, mode) in condeyModesLang"
                     @click="setMode(mode)"
                     :class="{'active': condey.mode === mode}">
                    <div :class="`icon ${mode}`"></div>
                    <div class="title hide-xs">{{label}}</div>
                </div>
            </div>
        </div>

        <div class="inner-block" style="align-items: flex-start; height: 70px">
            <div class="label-block hide-xs">
                <div class="title"></div>
            </div>
            <div class="content-block" style="">
                <div class="ext-mode-btn" @click="togglePowerfull()"
                     :class="{'active': condey.powerfull === 'on'}">
                    <img class="active hide-xs" src="/images/svg/btns/active/mode-powerfull.svg">
                    <img class="inactive hide-xs" src="/images/svg/btns/mode-powerfull.svg">
                    <img class="active hide-md" src="/images/svg/btns/small/active/mode-powerfull.svg">
                    <img class="inactive hide-md" src="/images/svg/btns/small/mode-powerfull.svg">
                </div>

                <div class="ext-mode-btn" @click="toggleEconomy()"
                     :class="{'active': condey.economy === 'on', 'disabled': disableEconomyMode}">
                    <img class="active hide-xs" src="/images/svg/btns/active/mode-econom.svg">
                    <img class="inactive hide-xs" src="/images/svg/btns/mode-econom.svg">
                    <img class="active hide-md" src="/images/svg/btns/small/active/mode-econom.svg">
                    <img class="inactive hide-md" src="/images/svg/btns/small/mode-econom.svg">
                </div>

                <div class="ext-mode-btn" @click="toggleStreamer()"
                     :class="{'active': condey.streamer === 'on', 'disabled': disableStreamerMode}">
                    <img class="active hide-xs" src="/images/svg/btns/active/mode-streamer.svg">
                    <img class="inactive hide-xs" src="/images/svg/btns/mode-streamer.svg">
                    <img class="active hide-md" src="/images/svg/btns/small/active/mode-streamer.svg">
                    <img class="inactive hide-md" src="/images/svg/btns/small/mode-streamer.svg">
                </div>
            </div>
        </div>


        <div class="inner-block temp-ctrl">
            <div class="label-block">
                <div class="title">Целевая температура</div>
            </div>
            <div class="content-block">
                <div class="temp-minus temp-ctrl-btn"
                     :class="{'disabled': disableTempCtrl}"
                     @click="setTemperature(-1)"></div>
                <div style="height: 54px">
                    {{condey.set_temp}}<span class="celsius-sign">°C</span>
                </div>
                <div class="temp-plus temp-ctrl-btn"
                     :class="{'disabled': disableTempCtrl}"
                     @click="setTemperature(1)"></div>
            </div>
        </div>

        <div class="inner-block">
            <div class="label-block">
                <div class="title">
                    Мощность потока
                    <span v-if="+condey.fan_speed > 0">{{condey.fan_speed}}/{{fanSpeedCount}}</span>
                    <span v-else>автоматическая</span>
                </div>
                <div class="help-info open-help-tooltip" @click="popups.speed=true"></div>
            </div>
            <div class="content-block flow-speed-ctrl">
                <div class="like-slider" @mouseleave="speedDivHovered = 0">
                    <div class="ctrl-btn-tupo" v-for="speed in fanSpeedCount"
                         :class="{'active': !speedDivHovered && speed <= condey.fan_speed, 'hover': speed <= speedDivHovered}"
                         @click="setFanSpeed(speed)"
                         @mouseover="speedDivHovered = speed"
                         :key="speed"></div>
                </div>
                <div class="flow-auto-ctrl" @click="setFanSpeed(condeyFanSpeed.auto)"
                     :class="{'active': condey.fan_speed === condeyFanSpeed.auto}">
                    Авто
                </div>
            </div>
        </div>

        <div class="inner-block">
            <div class="label-block">
                <div class="title">Режим заслонок</div>
                <div class="help-info open-help-tooltip" @click="popups.flow=true"></div>
            </div>
            <div class="content-block flow-direction-ctrl">
                <!--<div class="flow-btn" v-for="(label, mode) in condeyFlowLang"
                     @click="setFlow(mode)"
                     :class="{'active': condey.flow === mode}">
                    <div :class="`icon flow-${mode}`"></div>
                    <div class="title">{{label}}</div>
                </div>-->

                <div class="flow-btn"
                     @click="setFlow(condeyFlow.vert)"
                     :class="{'active': condey.flow === condeyFlow.vert}">
                    <div :class="`icon flow-${condeyFlow.vert}`"></div>
                    <div class="title">{{condeyFlowLang[condeyFlow.vert]}}</div>
                </div>

                <div class="flow-btn"
                     @click="setFlow(condeyFlow.horizont, disableFlowH)"
                     :class="{'active': condey.flow === condeyFlow.horizont, 'disabled': disableFlowH}">
                    <div :class="`icon flow-${condeyFlow.horizont}`"></div>
                    <div class="title">{{condeyFlowLang[condeyFlow.horizont]}}</div>
                </div>

                <div class="flow-btn"
                     @click="setFlow(condeyFlow.all, disableEconomyMode)"
                     :class="{'active': condey.flow === condeyFlow.all, 'disabled': disableFlow3D}">
                    <div :class="`icon flow-${condeyFlow.all}`"></div>
                    <div class="title">{{condeyFlowLang[condeyFlow.all]}}</div>
                </div>

            </div>
        </div>

        <my-popup v-model="popups.mode" title="Режимы" scroll="1">
            <div style="display: flex; flex-wrap: wrap;">
                <div class="tooltip-line">
                    <div class="icon cool"></div>
                    <div>
                        <div class="title">Охлаждение</div>
                        <div class="descr">В этом режиме осуществляется охлаждение воздуха в помещении.</div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon heat"></div>
                    <div>
                        <div class="title">Нагрев</div>
                        <div class="descr">В этом режиме осуществляется нагрев воздуха в помещении.</div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon auto"></div>
                    <div>
                        <div class="title">Авто</div>
                        <div class="descr">В автоматическом режиме кондиционер поддерживает заданный уровень температуры в
                            помещении, и в зависимости от изменения внешних условий кондиционер будет сам автоматически изменять
                            режимы работы для поддержания заданной температуры.
                        </div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon vent"></div>
                    <div>
                        <div class="title">Вентиляция</div>
                        <div class="descr">Этот режим используется для равномерного распределения воздуха в помещении.
                            При этом работает лишь вентилятор внутреннего блока, без компрессора. 
                        </div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon dry"></div>
                    <div>
                        <div class="title">Осушение</div>
                        <div class="descr">Режим, при котором осуществляется уменьшение влажности воздуха в помещении.</div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon powerfull-sm"></div>
                    <div>
                        <div class="title">Powerfull</div>
                        <div class="descr">Для бысторго достижения заданной температуры на 20 минут включается максимальная скорость вентилятора внутренного блока.</div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon econom-sm"></div>
                    <div>
                        <div class="title">Ecomon</div>
                        <div class="descr">Ограничивает максимальное потребление энергии наружным блоком.</div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon streamer-sm"></div>
                    <div>
                        <div class="title">Streamer</div>
                        <div class="descr">Создает высокоскоростной поток электоронов с очень мощной окисляющей способностью, устраняет неприятные запахи и уничтожая вирусы.</div>
                    </div>
                </div>
            </div>
        </my-popup>

        <my-popup v-model="popups.flow" title="Заслонки" scroll="1">
            <div style="display: flex; flex-wrap: wrap;">
                <div class="tooltip-line">
                    <div class="icon flow-horizont_on"></div>
                    <div>
                        <div class="title">Горизонтальное</div>
                        <div class="descr">
                            Горизонтальные жалюзи начинают перемещаться "вверх-вниз"
                        </div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon flow-vert_on"></div>
                    <div>
                        <div class="title">Вертикальное</div>
                        <div class="descr">
                            Вертикальные жалюзи начинают перемещаться "влево-вправо"
                        </div>
                    </div>
                </div>
                <div class="tooltip-line">
                    <div class="icon flow-3d_on"></div>
                    <div>
                        <div class="title">Все направления</div>
                        <div class="descr">
                            Горизонтальные и вертикальные жалюзи перемещаются одновременно
                        </div>
                    </div>
                </div>
            </div>
        </my-popup>

        <my-popup v-model="popups.speed" title="Поток" scroll="1">
            <div class="tt-text">
                От скорости вентилятора зависит интенсивность обогрева или охлаждения помещения.
                Чем выше скорость, тем быстрее происходит установление необходимых температурных
                условий и тем больший объем воздуха пройдет через внутренний блок. Большинство
                моделей сплит-систем оснащены тремя - пятью скоростями работы и автоматическим
                выбором скорости вращения вентилятора. При автоматическом регулировании скорости
                микропроцессор кондиционера может сам выбрать скорость вращения исходя из разницы
                между заданной температурой и температурой в помещении. При большой разнице
                выбирается большая скорость. В режиме осушения вентилятор работает
                на минимальных оборотах.
            </div>
        </my-popup>

    </div>
</template>


<script>
    import {
        condeyFanSpeed, condeyFlow, condeyModes, condeyTempLimits,
        condeyModesLang, condeyFlowLang, condeyFanSpeedLang, onOffLang,
        connectionState, condeyBrands} from '../../../other/consts'
    import {cmdVals, devApi} from '../../../api/device'
    import cfg from '../../../config'
    import { mapActions } from 'vuex'
    import myPopup from '../../elements/popup'
    import materialSwitch from '../../elements/material-switch'

    /*const fanSpeedNum = {
        'min': 1,
        'mid': 2,
        'max': 3,
        'auto': 0,
    }
    const fanSpeedNumRev = {
        1: 'min',
        2: 'mid',
        3: 'max',
        0: 'auto',
    }
    const fanSpeedLimit = 3;*/

    let delays = {
        temp: false
    };

    export default {
        components:{
            myPopup,
            materialSwitch,
        },
        data() {
            return {
                condeyFanSpeed,
                condeyFlow,
                condeyModes,
                condeyTempLimits,
                connectionState,
                cmdVals,

                condeyModesLang,
                condeyFlowLang,
                condeyFanSpeedLang,
                onOffLang,
                condeyBrands,
                // fanSpeedNum,
                // fanSpeedLimit,

                condey: {
                    set_temp: 27,
                    streamer: 'off',
                    powerfull: 'off',
                    economy: 'off',
                    flow: 'horizont_on',
                    mode: 'cool',
                    fan_speed: 'mid',
                    power: 'off',
                    brand: '',
                },

                speedDivHovered: 0,

                popups:{
                    mode: false,
                    flow: false,
                    speed: false,
                },
                loading: { }
            }
        },
        methods: {
            calcColor(temp) {
                let colorLow = '039BE5';
                let colorHi = 'EF6C00';
                let colRes = '#';
                let l = condeyTempLimits.min;
                let h = condeyTempLimits.max;
                for (let i = 0; i < 3; i++) {
                    let low = parseInt(colorLow.substr(i * 2, 2), 16);
                    let hi = parseInt(colorHi.substr(i * 2, 2), 16);
                    colRes += Math.round(low + ((temp - l) / (h - l)) * (hi - low)).toString(16);
                }
                return colRes;
            },
            _mqttCtrl(action, val) {
                // devApi.mqttCtrl.ctrl(this.$mqtt, this.device, action, val);
                devApi.http.ctrl(this.devId, action, val);
                return;
                let devId = this.devId;
                if (val !== undefined && !this.loading[devId][action]) {
                    this.$set(this.loading[devId], action, true);
                    devApi.mqttCtrl.ctrl(this.$mqtt, this.device, action, val);
                    let waitingTimer = setTimeout(() => {
                        this.loading[devId][action] = false
                        this.showCtrlFailAlert();
                        devApi.http.addFailStat(devId)
                    }, cfg.mqtt.cmdTimeout)
                    this.$mqtt.addListener(`dev_${this.device.serial}_${action}_single`,
                        `^/devices/conditioner/controls/${this.device.serial}/out/${action}$`,
                        (matches, msg) => {
                            this.loading[devId][action] = false
                            clearTimeout(waitingTimer)
                        }, {
                            once: true,
                        })
                }
            },
            setTemperature(d) {
                if(this.disableTempCtrl) return;
                if(!this.condey.set_temp) this.condey.set_temp = 25;
                this.condey.set_temp = parseInt(this.condey.set_temp);
                this.condey.set_temp = d + this.condey.set_temp;
                let minT = condeyTempLimits[this.condey.brand] ? condeyTempLimits[this.condey.brand].min : 18;
                let maxT = condeyTempLimits[this.condey.brand] ? condeyTempLimits[this.condey.brand].max : 32;
                if(this.condey.set_temp < minT) this.condey.set_temp = minT;
                if(this.condey.set_temp > maxT) this.condey.set_temp = maxT;

                if(delays.temp) clearTimeout(delays.temp);
                delays.temp = setTimeout(()=> {
                    this._mqttCtrl(cmdVals.setTemp, this.condey.set_temp)
                }, 1000);
            },

            setFlow(mode, disabled = false) {
                if(disabled) return;
                this.condey.flow = this.condey.flow !== mode ? mode : condeyFlow.off;
                this._mqttCtrl(cmdVals.flow, this.condey.flow)
            },
            setMode(mode) {
                this.condey.mode = mode;
                this._mqttCtrl(cmdVals.mode, mode)
            },
            setFanSpeed(speed) {
                // this.condey.fan_speed = fanSpeedNumRev[speed];
                this.condey.fan_speed = speed;
                this._mqttCtrl(cmdVals.fanSpeed, this.condey.fan_speed.toString())
            },
            setPower() {
                devApi.http.ctrl(this.devId, 'isOn', this.condey.power === 'on');
                // this._mqttCtrl(cmdVals.power, this.condey.power)
            },

            togglePowerfull(){
                this.condey.powerfull = this.condey.powerfull === 'on' ? 'off' : 'on';
                this._mqttCtrl(cmdVals.powerfull, this.condey.powerfull)
            },
            toggleStreamer(){
                if(this.disableStreamerMode) return;
                this.condey.streamer = this.condey.streamer === 'on' ? 'off' : 'on';
                this._mqttCtrl(cmdVals.streamer, this.condey.streamer)
            },
            toggleEconomy(){
                if(this.disableEconomyMode) return;
                this.condey.economy = this.condey.economy === 'on' ? 'off' : 'on';
                this._mqttCtrl(cmdVals.economy, this.condey.economy)
            },

            _copyDev() {
                this.condey = {...this.device}
            },
            ...mapActions([
                'showCtrlFailAlert'
            ])
        },
        created() {
            _.each([
                'set_temp',
                'streamer',
                'powerfull',
                'economy',
                'flow',
                'mode',
                'fan_speed',
                'power',
                'brand',
                'model_name',
            ], (p) => {
                this.$watch('device.' + p, (newVal, oldVal) => {
                    this.condey[p] = newVal;
                })
            })
            this._copyDev();
            if(this.loading[this.devId] === undefined){
                this.$set(this.loading, this.devId, {});
            }
        },
        watch: {
            devId(newVal, oldVal) {
                this._copyDev();
                if (this.loading[newVal] === undefined) {
                    this.$set(this.loading, newVal, {});
                }
            }
        },
        computed: {
            devId() {
                return this.$route.params.devId;
            },
            device() {
                return this.$store.state.devs.all[this.devId];
            },
            devOffline(){
                return this.device.connection !== connectionState.online
            },
            fanSpeedCount(){
                return this.condey.brand && this.condey.brand.toLowerCase() === condeyBrands.Daikin.toLowerCase() ? 5 : 3;
            },
            disableTempCtrl(){
                return this.condey.mode === condeyModes.dry || this.condey.mode === condeyModes.vent;
            },
            disableFlowH(){
                return ['Kentatsu', 'Midea', 'Daichi'].includes(this.condey.brand)
                    || this.condey.brand === 'Daikin' && ["FTXP", "FTXB", "FLXS", "FVXM", "FVXS"].includes(this.condey.model_name);
            },
            disableFlow3D(){ // 1 к 1 как disableFlowH
                return ['Kentatsu', 'Midea', 'Daichi'].includes(this.condey.brand)
                    || this.condey.brand === 'Daikin' && ["FTXP", "FTXB", "FLXS", "FVXM", "FVXS"].includes(this.condey.model_name);
            },
            disableEconomyMode(){
                return ['Kentatsu', 'Midea', 'Daichi'].includes(this.condey.brand)
                    || this.condey.brand === 'Daikin' && this.condey.model_name === "FLXS";
            },
            disableStreamerMode(){
                return  !(this.condey.brand === 'Daikin' && this.condey.model_name === "FTXM");
            },
        },
    }
</script>
